import { useState, useEffect } from 'react'
import Box from '@mui/joy/Box'
import Sheet from '@mui/joy/Sheet'
import { validateTemplate } from '../common/templateValidator'
import { canvasUtils } from '../common/canvasUtils'
import { Loading } from '../components/ui/Loading'
import { TemplateAPI } from '../api/TemplateAPI'
import { useParams } from 'react-router-dom'
import { TEMPLATE_TYPES, TEMPLATE_TYPE_CODES } from '../consts'
import { FontLoader } from '../components/ui/FontLoader'
import { Interpolator } from '../components/InterpolatorV2'
import { v4 as uuidv4 } from 'uuid'
import { mapBlogFields } from '../common/utils'

const TEST_URL =
    'https://dev-bruce-user.s3.us-west-1.amazonaws.com/blob-svc/145ff0e826b3436fb6655b553c15535b.png'
const ARTICLE = {
    id: '52ac15ac-dcb5-499d-9a97-b641695f1adc',
    title: 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups',
    text: 'Have you ever been laying in bed, trying to get to sleep, and the gears in your head will just not stop turning? In other words, there is nothing worse than being restless the next day because you couldn’t get any sleep the night before, especially when you feel you got in the bed at a decent hour! Bedtime affirmations are an excellent way to fix this, if you give it a chance.\nYour nighttime routine can make or break the entire next day. As a result, learning how to wind down is an art form that we all need to get right. Exploring what helps ease your body at night is a journey and finding the right thing to do consistently for yourself takes time and lots of trial and error.',
    cover_image: `${TEST_URL}?cache_key=${uuidv4()}`,
}

export const LibraryTemplatePreview = () => {
    const { templateId } = useParams()
    const [fonts, setFonts] = useState(null)
    const [isReady, setIsReady] = useState(false)
    const [template, setTemplate] = useState(null)
    const [img, setImg] = useState(null)

    useEffect(() => {
        TemplateAPI.get(templateId)
            .then((response) => {
                let fonts = []
                let objects = response.data.canvas.objects
                for (let i = 0; i < objects.length; i++) {
                    const obj = objects[i]
                    if (
                        obj.type === 'template-textbox' ||
                        obj.type === 'textbox' ||
                        obj.type === 'i-text' ||
                        obj.type === 'text'
                    ) {
                        fonts.push({
                            font: obj.fontFamily,
                            weight: obj.fontWeight,
                        })
                    }
                }
                console.log(fonts)
                setFonts(fonts)
                setTemplate(response.data)
            })
            .catch((e) => {
                console.log(e)
            })
    }, [])

    const handleTemplate = (data) => {
        setIsReady(false)
        setImg(data[0].dataUrl)
    }

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Sheet
                variant="outlined"
                sx={{
                    width: '75%',
                    height: '75%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                {fonts && (
                    <FontLoader
                        fontDataArr={fonts}
                        onStatusChanged={() => setIsReady(true)}
                    />
                )}
                {isReady && (
                    <Interpolator
                        varsMap={mapBlogFields(ARTICLE)}
                        templates={[template]}
                        onStatusChanged={handleTemplate}
                    />
                )}
                {img && <img src={img} />}
            </Sheet>
        </Box>
    )
}
